export const CHANGE_FORM = "Property/FORM_UPDATE";
export const REMOVE_FORM = "Property/FORM_CLEAR";
